import React, { useState } from 'react';
import { householdAPI } from '../services/api';
import './Modal.css';

function CreateHouseholdModal({ onClose, onSuccess }) {
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await householdAPI.create(name);
      if (onSuccess) onSuccess(response.data);
      setName('');
      onClose();
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to create household');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Create Household</h2>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Household Name</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g., Alvarez Family"
              required
              autoFocus
            />
          </div>

          <div className="modal-actions">
            <button type="button" onClick={onClose} className="btn-cancel">
              Cancel
            </button>
            <button type="submit" disabled={loading} className="btn-submit">
              {loading ? 'Creating...' : 'Create Household'}
            </button>
          </div>
        </form>

        <div className="modal-info">
          <p>💡 After creating, you'll get an invite code to share with family members!</p>
        </div>
      </div>
    </div>
  );
}

export default CreateHouseholdModal;
